import { request } from '@/apis/http';
import axios from 'axios';
import { DateWarehouseVo, DoLoginReq, SaTokenInfoVo, SysMenuVo, SysUserInfoVo } from 'typings/openapi';

/** 登录 */
export const BiLogin = (data: DoLoginReq) => {
  return request<SaTokenInfoVo>('/aio/date/warehouse/doLogin', {
    method: 'POST',
    data,
  });
};

/** 根据标识获取数据仓库logo信息 */
export const GetWarehouseInfo = (params: { identifier: string }) => {
  return axios
    .get<{ data: DateWarehouseVo }>('/api/aio/date/warehouse/getWarehouseInfo', {
      params,
    })
    .then((resp) => resp.data.data);
};

/** 获取菜单列表 */
export const GetBiMenu = () => {
  return request<SysMenuVo[]>('/aio/date/warehouse/getMenuTree', {
    method: 'POST',
  });
};

/** 登录 */
export const BiGetUserInfo = () => {
  return request<SysUserInfoVo>('/aio/date/warehouse/getUserInfo', {
    method: 'GET',
  });
};
